import axios from 'axios';
import urlBuilder from './helper/urlBuilder';

async function getDate() {
    let res;
    try {
        res = await axios.request({
            method: 'GET',
            validateStatus: (status) => status <= 500,
            url: `${urlBuilder()}/date`,
        });
    } catch (error) {
        throw new Error('Une erreur interne est survenue, merci de réessayer ultérieurement.');
    }

    const { status, data } = res;
    if (status !== 200) {
        throw new Error('Une erreur interne est survenue, merci de réessayer ultérieurement.');
    }

    return data;
}

export default { getDate };
